var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{model:{value:(_vm.showAlertLogin),callback:function ($$v) {_vm.showAlertLogin=$$v},expression:"showAlertLogin"}},[_vm._v(_vm._s(_vm.textAlertLogin)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }